import { ErrorCode } from './code/error-code';
import { NavigatorUtil } from './utils/navigator-util';
import { LsUtil } from './utils/ls-util';

export class TwcaCertLib {
  defaultMima = '123456';

  constructor() {

  }

  // 與舊版名稱相容
  DoIDPaaSCertCheck = this.certCheck;
  doIDPaaSCertCheck = this.certCheck;
  DoIDPaaSCertImport = this.certImport;
  doIDPaaSCertImport = this.certImport;
  DoIDPaaSCertDelete = this.certDelete;
  doIDPaaSCertDelete = this.certDelete;
  DoIDPaaSSign = this.certSign;
  doIDPaaSSign = this.certSign;
  DoIDPaaSCertSign = this.certSign;
  doIDPaaSCertSign = this.certSign;

  /**
   * 檢查本地憑證
   *
   * @param memberNo   身分證字號
   * @param certFilter 挑選憑證用的過濾器
   * @param callback   callback(code, msg, reserved, data)
   */
  certCheck(memberNo, certFilter, callback) {
    let oRtn = {
      code: '1185010',
      msg: ErrorCode['1185010'],
      reserved: {},
      data: {}
    };
    certFilter = certFilter.replace(/\[@cn]/g, memberNo);

    twcaLib.SelectSignerEx(certFilter, '', '', '', '', 0x04 | 0x08 | 0x1000, 0, '',
      (code, msg, token, data) => {
        if (code === 0) {
          // 已挑到該 memberNo 的憑證
          let certObj = JSON.parse(data);

          // 回傳已有的憑證
          oRtn.code = code;
          oRtn.msg = msg;
          oRtn.data.sn = certObj.sn;
          oRtn.data.cn = certObj.cn;
          oRtn.data.certb64 = certObj.certb64;
          oRtn.data.subdn = certObj.subdn;

          callback(oRtn.code, oRtn.msg, oRtn.reserved, oRtn.data);
        } else {
          // 當 code = 5010，無憑證並清除 TWCAAccountUqiDeviceID
          if (memberNo && (code === 5010)) {
            try {
              let deviceIDSet = localStorage.getItem('TWCAAccountUqiDeviceID');

              if (deviceIDSet) {
                deviceIDSet = JSON.parse(deviceIDSet);

                if (deviceIDSet[memberNo]) {
                  this._removeAccountDeviceID(memberNo);
                }
              }
            } catch (err) {
              oRtn.code = '1185012';
              oRtn.msg = ErrorCode['1185012'];

              callback(oRtn.code, oRtn.msg, oRtn.reserved, oRtn.data);
              return;
            }
          } else if (code !== 0) {
            callback('118' + code, msg, {}, {});
            return;
          }

          // Gen CSR: 前置動作
          let deviceID = NavigatorUtil.getDeviceID('', memberNo);

          if (deviceID === '') {
            oRtn.code = '1185011';
            oRtn.msg = ErrorCode['1185011'];
            callback(oRtn.code, oRtn.msg, oRtn.reserved, oRtn.data);
            return;
          }

          this._makeTwcaCryptoLibCSR(memberNo, this.defaultMima).then((r) => {
            oRtn.code = '1185011';
            oRtn.msg = ErrorCode['1185011'];
            oRtn.data = {
              idpaasCertTx: {
                DeviceType: NavigatorUtil.getDeviceType(),
                DeviceId: deviceID,
                VenderId: NavigatorUtil.getVenderID(),
                CSR: r.csr,
                UserAgent: navigator.userAgent
              },
              b64Key: r.b64Key
            };

            callback(oRtn.code, oRtn.msg, oRtn.reserved, oRtn.data);
          }).catch((e) => {
            console.log(e);
            oRtn.code = '1185011';
            oRtn.msg = ErrorCode['1185011'];

            callback(oRtn.code, oRtn.msg, oRtn.reserved, oRtn.data);
          });
        }
      }
    );
  }

  /**
   * 匯入憑證
   *
   * @param businessNo 應用平台代號
   * @param memberNo   身分證字號
   * @param x509Cert   x509 憑證
   * @param b64Key     b64 key
   * @param userPin    憑證密碼
   * @param deviceID   裝置 id，由 twcaLib 生成
   * @param callback   callback(code, msg, reserved, data)
   * @returns
   */
  certImport(businessNo, memberNo, x509Cert, b64Key, userPin, deviceID, callback) {
    let oRtn = null;
    let defaultMima = this.defaultMima;

    let importCertReturn = (code, msg, token, data) => {
      if (code === 0) {
        oRtn = JSON.parse(data);
        let certFilter = '//S_SN=' + oRtn.sn + '//';

        twcaLib.SelectSignerEx(certFilter, '', '', defaultMima, '', 14, '', '', (ccc, mmm, ttt, ddd) => {
          if (ccc === 0) {
            twcaLib.ChangePIN(defaultMima, userPin, (c) => {
              callback('0', ErrorCode['0'], {}, {
                sn: oRtn['sn'],
                cn: oRtn['cn'],
                notBefore: oRtn['ntb'],
                notAfter: oRtn['nta'],
                issuer: oRtn['issdn'],
                subject: oRtn['subdn'],
                certFinger: oRtn['certfinger'],
                b64Cert: oRtn['certb64']
              });
            });
          } else {
            callback('118' + ccc, mmm, {}, {});
          }
        });
      } else {
        callback('118' + code, msg, {}, {});
      }
    };

    if (NavigatorUtil.isTWID()) {
      try {
        twcaLib.ImportCert(businessNo, memberNo, x509Cert, defaultMima, importCertReturn);
      } catch (err) {
        console.log(err);
        callback('1185001', ErrorCode['1185001'], {}, {});
      }
    } else {
      try {
        twcaLib.ImportCert(memberNo, defaultMima, b64Key, x509Cert, '', importCertReturn, deviceID);
      } catch (err) {
        console.log(err);
        callback('1185001', ErrorCode['1185001'], {}, {});
      }
    }
  }

  /**
   * 用本地憑證簽 PKCS1
   *
   * @param memberNo    身分證字號
   * @param certFilter  挑選憑證用的過濾器
   * @param userPin     憑證密碼
   * @param toBeSignArr 已 Hash 的 JsonArray
   * @param callback    callback(code, msg, reserved, data)
   * @returns
   */
  certSign(memberNo, certFilter, userPin, toBeSignArr, callback) {
    let oRtn = {
      'code': '',
      'msg': '',
      'reserved': {},
      'data': {}
    };

    if (memberNo === '') {
      callback('1185112', ErrorCode['1185112'], null, null);
      return;
    }

    certFilter = certFilter.replace(/\[@cn]/g, memberNo);

    twcaLib.SelectSignerEx(certFilter, '', '', userPin, '', 14, '', '', (code, msg, token, data) => {
      if (code !== 0) {
        oRtn.code = code;
        oRtn.msg = msg;
        oRtn.reserved = token;
        oRtn.data = data;

        callback('118' + oRtn.code, oRtn.msg, oRtn.reserved, oRtn.data);
      } else {
        twcaLib.SignPkcs1FromHash(toBeSignArr, (code, msg, token, data) => {
          oRtn.code = code;
          oRtn.msg = msg;
          oRtn.reserved = token;
          if (code === 0) {
            let dataJobj = JSON.parse(data);
            oRtn.data = {
              'signature': dataJobj['signature'],
              'certb64': dataJobj['certb64']
            };
          } else {
            oRtn.code = '118' + code;
            oRtn.data = null;
          }

          callback(oRtn.code, oRtn.msg, oRtn.reserved, oRtn.data);
        });
      }
    });
  }

  /**
     * 用本地憑證簽 PKCS7，SHA256
     *
     * @param memberNo    身分證字號
     * @param certFilter  挑選憑證用的過濾器
     * @param userPin     憑證密碼
     * @param tbs         待簽章明文
     * @param callback    callback(code, msg, reserved, data)
     * @returns
     */
  certSignPkcs7(memberNo, certFilter, userPin, tbs, callback) {
    let oRtn = {
      'code': '',
      'msg': '',
      'reserved': {},
      'data': {}
    };

    if (memberNo === '') {
      callback('1185112', ErrorCode['1185112'], null, null);
      return;
    }

    certFilter = certFilter.replace(/\[@cn]/g, memberNo);

    twcaLib.SelectSignerEx(certFilter, '', '', userPin, '', 14, '', '', (code, msg, token, data) => {
      if (code !== 0) {
        oRtn.code = code;
        oRtn.msg = msg;
        oRtn.reserved = token;
        oRtn.data = data;

        callback('118' + oRtn.code, oRtn.msg, oRtn.reserved, oRtn.data);
      } else {
        twcaLib.SignPkcs7(tbs, 0x2000, (code, msg, token, data) => {
          oRtn.code = code;
          oRtn.msg = msg;
          oRtn.reserved = token;
          if (code === 0) {
            let dataJobj = JSON.parse(data);
            oRtn.data = {
              'signature': dataJobj['signature'],
              'certb64': dataJobj['certb64']
            };
          } else {
            oRtn.code = '118' + code;
            oRtn.data = null;
          }

          callback(oRtn.code, oRtn.msg, oRtn.reserved, oRtn.data);
        });
      }
    });
  }

  /**
   * 用本地憑證簽 PKCS7，SHA256/UTF-8
   *
   * @param memberNo    身分證字號
   * @param certFilter  挑選憑證用的過濾器
   * @param userPin     憑證密碼
   * @param tbs         待簽章明文
   * @param callback    callback(code, msg, reserved, data)
   * @returns
   */
  certSignPkcs7Utf8(memberNo, certFilter, userPin, tbs, callback) {
    let oRtn = {
      'code': '',
      'msg': '',
      'reserved': {},
      'data': {}
    };

    if (memberNo === '') {
      callback('1185112', ErrorCode['1185112'], null, null);
      return;
    }

    certFilter = certFilter.replace(/\[@cn]/g, memberNo);

    twcaLib.SelectSignerEx(certFilter, '', '', userPin, '', 14, '', '', (code, msg, token, data) => {
      if (code !== 0) {
        oRtn.code = code;
        oRtn.msg = msg;
        oRtn.reserved = token;
        oRtn.data = data;

        callback('118' + oRtn.code, oRtn.msg, oRtn.reserved, oRtn.data);
      } else {
        twcaLib.SignPkcs7(tbs, 0x2000 | 0x0001, (code, msg, token, data) => {
          oRtn.code = code;
          oRtn.msg = msg;
          oRtn.reserved = token;
          if (code === 0) {
            let dataJobj = JSON.parse(data);
            oRtn.data = {
              'signature': dataJobj['signature'],
              'certb64': dataJobj['certb64']
            };
          } else {
            oRtn.code = '118' + code;
            oRtn.data = null;
          }

          callback(oRtn.code, oRtn.msg, oRtn.reserved, oRtn.data);
        });
      }
    });
  }

  /**
   * 刪除憑證
   *
   * @param memberNo   身分證字號
   * @param certFilter 挑選憑證用的過濾器
   * @param callback   callback(code, msg, reserved, data)
   */
  certDelete(memberNo, certFilter, callback) {
    let certRefObjName = 'TWCACertIdxRef';
    let deviceIDRefName = 'TWCAAccountUqiDeviceID';

    if (memberNo === '') {
      callback('1185112', ErrorCode['1185112'], null, null);
      return;
    }

    certFilter = certFilter.replace(/\[@cn]/g, memberNo);

    twcaLib.SelectSignerEx(certFilter, '', '', '', '', 0x04 | 0x08 | 0x1000, 0, '',
      (code, msg, token, data) => {
        if (code === 0) {
          let certObj = JSON.parse(data);

          let certIdxRef = LsUtil.getLSAsObj(certRefObjName);

          let certRefKey = '';
          for (let key in certIdxRef) {
            if (certObj.subdn === certIdxRef[key].subject) {
              certRefKey = key;
              break;
            }
          }

          if (certRefKey !== '') {
            delete certIdxRef[certRefKey];
            LsUtil.setLS(certRefObjName, certIdxRef);
            LsUtil.removeLS(certRefKey);
            LsUtil.removeLS(memberNo);
          }

          try {
            let TWCAAccountUqiDeviceIDByOU = 'TWCAAccountUqiDeviceIDByOU';
            let ou = this._fromSubjectGetOU(certObj.subdn);
            let deviceIDSet = localStorage.getItem(TWCAAccountUqiDeviceIDByOU);
            if (deviceIDSet) {
              deviceIDSet = JSON.parse(deviceIDSet);
              if (deviceIDSet[ou]) {
                if (deviceIDSet[ou][memberNo]) {
                  delete deviceIDSet[ou][memberNo];
                  localStorage.setItem(TWCAAccountUqiDeviceIDByOU, JSON.stringify(deviceIDSet));
                }
              }
            }
          } catch (error) {
            console.log('刪除新資料結構TWCAAccountUqiDeviceIDByOU DeviceID 資料發生錯誤! ' + error);
          }

          let deviceIDRef = LsUtil.getLSAsObj(deviceIDRefName);
          if (deviceIDRef !== null && typeof deviceIDRef !== 'undefined') {
            delete deviceIDRef[memberNo];
            LsUtil.setLS(deviceIDRefName, deviceIDRef);
          }

          let blCertFound = false;
          if (certIdxRef !== null && typeof certIdxRef !== 'undefined') {
            for (let key in certIdxRef) {
              if (certObj.subdn === certIdxRef[key].subject) {
                blCertFound = true;
                break;
              }
            }
          }

          if (blCertFound) {
            callback('1189999', ErrorCode['1189999'], null, null);
          } else {
            callback('0', ErrorCode['0'], null, null);
          }
        } else {
          callback('1185010', ErrorCode['1185010'], null, null);
        }
      }
    );
  }

  /**
   * 變更憑證密碼
   *
   * @param memberNo   身分證字號
   * @param certFilter  挑選憑證用的過濾器
   * @param oldPassword   原憑證密碼
   * @param newPassword   新憑證密碼
   * @param callback   callback(code, msg, reserved, data)
   */
  doIDPaaSCertChangePin(memberNo, certFilter, oldPassword, newPassword, callback) {
    try {
      certFilter = certFilter.replace(/\[@cn]/g, memberNo);

      twcaLib.SelectSignerEx(certFilter, '', '', oldPassword, '', 14, '', '', (selectSignerExCode, selectSignerExMsg, selectSignerExReserved, selectSignerExData) => {
        if (selectSignerExCode === 0) {
          twcaLib.ChangePIN(oldPassword, newPassword, (changePinCode, changePinMsg, changePinReserved, changePinData) => {
            if (changePinCode === 0) {
              let changePinDataObj = JSON.parse(changePinData);
              callback('0', ErrorCode['0'], {}, {
                sn: changePinDataObj['sn'],
                cn: changePinDataObj['cn'],
                notBefore: changePinDataObj['ntb'],
                notAfter: changePinDataObj['nta'],
                issuer: changePinDataObj['issdn'],
                subject: changePinDataObj['subdn'],
                certFinger: changePinDataObj['certfinger'],
                b64Cert: changePinDataObj['certb64']
              });
            } else {
              callback('118' + changePinCode, changePinMsg, {}, {});
            }
          });
        } else {
          callback('118' + selectSignerExCode, selectSignerExMsg, {}, {});
        }
      });
    } catch (error) {
      console.error('doIDPaaSCertChangePin error:', error);
      callback('1189999', ErrorCode['1189999'], {}, {});
    }
  }

  _removeAccountDeviceID(userID) {
    let lsKey = 'TWCAAccountUqiDeviceID';
    try {
      let deviceIDSet = localStorage.getItem(lsKey);
      if (!deviceIDSet) {
        return;
      }

      deviceIDSet = JSON.parse(deviceIDSet);
      deviceIDSet[userID] = null;
      delete deviceIDSet[userID];
      localStorage.setItem(lsKey, JSON.stringify(deviceIDSet));
    } catch (e) {
      console.log(e);
    }
  }

  _makeTwcaCryptoLibCSR(userIdNo, userPin) {
    return new Promise((resolve, reject) => {
      let makeCSRReturn = (code, msg, token, data) => {
        if (code === 0) {
          let csrReturn = JSON.parse(data);

          resolve({
            errCode: '0',
            csr: csrReturn.csr,
            b64Key: csrReturn.b64Key ?? ''
          });
        } else {
          reject(`${code}-${msg}`);
        }
      };

      if (NavigatorUtil.isTWID()) {
        twcaLib.MakeCSR(2048, webcom, userIdNo, userPin, 0, makeCSRReturn);
      } else {
        twcaLib.MakeCSR(2048, 0x0200, userPin, userIdNo, makeCSRReturn);
      }
    });
  }

  _fromSubjectGetOU(subject) {
    let ou = '';
    let ouArr = subject.match(/(OU=[^,]+)/gm);
    try {
      //正反序subject處理
      if (subject.indexOf('C=') === 0) {
        ou = ouArr[ouArr.length - 1].replace('OU=', '');
      } else {
        ou = ouArr[0].replace('OU=', '');
      }
    } catch (error) {
      return '';
    }
    return ou;
  }
}
